import styled from "styled-components";
export const Content = styled.input`
  width: 350px;
  height: 52px;
  padding: 0px 20px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.secondary10};
  color: ${({ theme }) => theme.colors.secondary100};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
`;
